import { LogLevel } from 'angular-auth-oidc-client';

export const environment = {
  production: false,
  apiUrl: 'https://dxt-01.api.app.dev.dx-tract.de',
  apiBaseUrl: 'https://dxt-01.api.app.dev.dx-tract.de/api',
  isLocalDev: false,
  auth: {
    enabled: true,
    authority: 'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_xizdh6HAO',
    redirectUrl: 'https://dxt-01.app.dev.dx-tract.de/auth/callback',
    clientId: '66figd7qgt25tg1iel1okv6jkc',
    scope: 'email openid phone profile',
    responseType: 'code',
    postLogoutRedirectUri: 'https://dxt-01.app.dev.dx-tract.de',
    silentRenew: true,
    useRefreshToken: true,
    maxIdTokenIatOffsetAllowedInSeconds: 1000,
    customParamsAuthRequest: {},
    customParamsRefreshTokenRequest: {},
    customParamsEndSessionRequest: {},
    customParamsCodeRequest: {},
    disableIdTokenValidation: false,
    disableRefreshIdTokenAuthTimeValidation: false,
    ignoreNonceAfterRefresh: false,
    allowUnsafeReuseRefreshToken: false,
    autoUserInfo: false,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    secureRoutes: ['https://dxt-01.api.app.dev.dx-tract.de/api'],
    wellKnownEndpointUrl:
      'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_xizdh6HAO/.well-known/openid-configuration',
    logLevel: LogLevel.None,
  },
};
